import { Card, CardContent, CardHeader, CardTitle, Table, TableBody, TableCell, TableHead, TableHeader, TableRow } from '@1trading/react';
import type { UtrConversion } from '@/services/api/fiu-utr';

interface ConversionsCardProps {
  conversions: UtrConversion[];
}

// Persists after generation as an audit aid; the parent clears it on a new search
// (and, per a deliberate fix, at the start of each generate attempt).
export const ConversionsCard = ({ conversions }: ConversionsCardProps) => {
  if (conversions.length === 0) return null;
  return (
    <Card className="max-w-[900px] border-blue-500/40 bg-blue-500/5">
      <CardHeader>
        <CardTitle className="text-base">EUR conversions applied (rate at the time of each transaction)</CardTitle>
      </CardHeader>
      <CardContent>
        <Table>
          <TableHeader>
            <TableRow>
              <TableHead>Transaction</TableHead>
              <TableHead className="text-right">Original amount</TableHead>
              <TableHead className="text-right">EUR rate</TableHead>
              <TableHead className="text-right">amount_local (EUR)</TableHead>
            </TableRow>
          </TableHeader>
          <TableBody>
            {conversions.map((conversion) => (
              <TableRow key={`${conversion.transactionNumber}:${conversion.currency}`}>
                <TableCell className="font-mono text-xs">{conversion.transactionNumber}</TableCell>
                <TableCell className="whitespace-nowrap text-right tabular-nums">
                  {conversion.amount} {conversion.currency}
                </TableCell>
                <TableCell className="text-right tabular-nums">{conversion.rate}</TableCell>
                <TableCell className="text-right tabular-nums">{conversion.amountLocal}</TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </CardContent>
    </Card>
  );
};
ConversionsCard.displayName = 'ConversionsCard';
